import { useQuery } from 'react-query';
import { getFCMetadata } from 'src/utils/Queries';

/**
 * Hook to check if Default_FC_PC should be shown for a given warehouse.
 *
 * Calls getFCMetadata and checks the fcType field. When the backend
 * disable_default_fc_pc feature flag is enabled for a warehouse,
 * getFCMetadata returns fcType="SSD". SSD warehouses should not
 * show Default_FC_PC in the UI.
 *
 * @param warehouseId - warehouse to query. Falls back to 'DEFAULT' if empty.
 * @returns { isDefaultFCPCEnabled, isLoading }
 */
export function useIsDefaultFCPCEnabled(warehouseId?: string) {
    const effectiveWarehouseId = warehouseId || 'DEFAULT';

    const { data, isLoading } = useQuery(
        ['default-fc-pc-feature-flag', effectiveWarehouseId],
        async () => {
            const response = await getFCMetadata(effectiveWarehouseId);
            if (!response) return true;
            // fcType="SSD" means disable_default_fc_pc is on → hide Default_FC_PC
            return response.fcType !== 'SSD';
        },
        {
            staleTime: 10 * 60 * 1000,
            cacheTime: 15 * 60 * 1000,
            retry: 1,
            refetchOnWindowFocus: false,
        }
    );

    return {
        isDefaultFCPCEnabled: data ?? true,
        isLoading,
    };
}
